import * as Yup from "yup";
import { React, useEffect, useState } from "react";
import "react-toastify/dist/ReactToastify.css";
import {
  Stack,
  Container,
  TextField,
  Button,
  Avatar,
  FormControl,
  FormLabel,
  RadioGroup,
  FormControlLabel,
  Radio,
  CircularProgress,
  InputAdornment
} from "@mui/material";
import Grid from "@mui/material/Grid";
import LocalizationProvider from "@mui/lab/LocalizationProvider";
import AdapterDateFns from "@mui/lab/AdapterDateFns";
import DatePicker from "@mui/lab/DatePicker";
import moment from "moment";
import {
  GetAllChapter,
  fetchCityList,
  fetchStateList,
  fetchchapterbyuser
} from "../../../utils/common";
import { checkMemberValidation, insertmember, UpdateMember } from "src/api/commonapi";
import Select from "react-select";
import { notification } from "src/utils/messages";
import ChapterSelectDropDown from "src/components/ChapterSelectDropDown";
import { gender } from "src/constant/variable";
import { fetchGstDetailsbynumberApi } from "src/api/invoiceApi";
// ----------------------------------------------------------------------

export default function MemberForm({ setStep, data, step, memberlist }) {
  let loginUser = JSON.parse(localStorage.getItem("userData"));
  const memberTypeOption = [
    { value: 0, label: "Member" },
    { value: 1, label: "President" },
    { value: 2, label: "Vice President" },
    { value: 3, label: "ST" },
    { value: 4, label: "LVH" }
  ];
  let d = new Date();
  const [citylist, setcitylist] = useState(null);
  const [statelist, setstatelist] = useState(null);
  const [chapterlist, setchapterlist] = useState(null);
  const [chaptlist, setchaptlist] = useState([]);
  const [response, setresponse] = useState(0);
  const [formdata, setformdata] = useState({
    chpt_id: 0,
    joining_date: "",
    due_date: "",
    memberType: 0,
    gender: 0,
    m_name: "",
    type: 0,
    m_email_id: "",
    mobile_no: "",
    password: "",
    business_name: "",
    business_category: "",
    business_desc: "",
    state_id: 0,
    city_id: 0,
    photo: "",
    reference_m_id: 0,
    i_gstno: "",
    i_gst_business_name: "",
    i_gst_business_address: ""
  });
  const [joindate, setjoinDate] = useState(null);
  const [duedate, setdueDate] = useState(null);
  const [setfile, setFile] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [originalGstBusinessName, setOriginalGstBusinessName] = useState("");
  const [isGstVerified, setIsGstVerified] = useState(false);

  let startdate = {};
  let new_date = {};
  const setnewformdata = (e) => {
    e.preventDefault();
    if (e.target.name == "mobile_no") {
      if (e.target.value.length > 10) {
      } else {
        setformdata({ ...formdata, [e.target.name]: e.target.value });
      }
    } else if (e.target.name == "i_gstno") {
      setformdata({
        ...formdata,
        [e.target.name]: e.target.value,
        i_gst_business_name: "",
        i_gst_business_address: ""
      });
      setIsGstVerified(false);
      setOriginalGstBusinessName("");
    } else {
      setformdata({ ...formdata, [e.target.name]: e.target.value });
    }
  };
  useEffect(async () => {
    if (step == 3) {
      setformdata(data);
      setcitylist(await fetchCityList(data.state_id));
      if (data.i_gstno) {
        try {
          const gstResp = await fetchGstDetailsbynumberApi({ gst_no: data.i_gstno });
          if (gstResp.status === 1) {
            setOriginalGstBusinessName(gstResp.data?.business_name || "");
            setIsGstVerified(true);
          }
        } catch (e) {
          console.error("Failed to fetch initial GST details", e);
        }
      }
    }
    const chapterData = await fetchchapterbyuser(loginUser.city_id, loginUser.u_type);
    setchapterlist(chapterData);
    setchaptlist(chapterData);
    setstatelist(await fetchStateList());
  }, []);

  const handleStateSelect = async (selectedState) => {
    setcitylist(await fetchCityList(selectedState.value));
    setformdata({ ...formdata, state_id: selectedState.value });
  };
  const handleChapterSelect = async (selectedChapter) => {
    const selectedChapterData = chaptlist?.find((item) => item?.chpt_id == selectedChapter.value);
    const newStateId = selectedChapterData?.state_id || 0;
    const newCityId = selectedChapterData?.city_id || 0;
    if (newStateId) {
      setcitylist(await fetchCityList(newStateId));
    }
    setformdata({
      ...formdata,
      chpt_id: selectedChapter.value,
      state_id: newStateId,
      city_id: newCityId
    });
  };
  const handleCitySelect = async (selectedCity) => {
    setformdata({ ...formdata, city_id: selectedCity.value });
  };

  const handleChaptermemberType = async (selectedMemberType) => {
    setformdata({ ...formdata, memberType: selectedMemberType.value });
  };

  const fetchGstDetailsbynumber = async (gst_no) => {
    try {
      setIsLoading(true);
      const response = await fetchGstDetailsbynumberApi({ gst_no: gst_no });
      setIsLoading(false);

      if (response.status === 1) {
        const busName = response.data.business_name || "";
        setformdata((prev) => ({
          ...prev,
          i_gst_business_name: busName,
          i_gst_business_address: response.data.address
        }));
        setOriginalGstBusinessName(busName);
        setIsGstVerified(true);
        notification({
          type: "success",
          message: response.message
        })();
      } else {
        notification({
          type: "error",
          message: response.message
        })();
      }
    } catch (error) {
      setIsLoading(false);
      notification({
        type: "error",
        message: "Failed to fetch GST details"
      })();
    }
  };

  const handleSubmit = async () => {
    let resp = null;
    if (step == 2) {
      if (
        formdata.chpt_id !== 0 &&
        // formdata.gender != 0 &&
        formdata.m_name != "" &&
        formdata.mobile_no != "" &&
        formdata.password != "" &&
        formdata.business_name != "" &&
        formdata.business_category != "" &&
        formdata.joining_date != "" &&
        formdata.due_date != ""
      ) {
        let fdata = new FormData();
        fdata.append("chpt_id", formdata.chpt_id);
        fdata.append("gender", formdata.gender);
        fdata.append("m_name", formdata.m_name);
        fdata.append("photo", formdata.photo);
        fdata.append("mobile_no", formdata.mobile_no);
        fdata.append("m_email_id", formdata.m_email_id);
        fdata.append("password", formdata.password);
        fdata.append("type", formdata.memberType);
        fdata.append("business_name", formdata.business_name);
        fdata.append("business_category", formdata.business_category);
        fdata.append("business_desc", formdata.business_desc);
        fdata.append("joining_date", formdata.joining_date);
        fdata.append("due_date", formdata.due_date);
        fdata.append("state_id", formdata.state_id);
        fdata.append("city_id", formdata.city_id);
        fdata.append("reference_m_id", formdata.reference_m_id);
        fdata.append("i_gstno", formdata.i_gstno);
        fdata.append("i_gst_business_name", formdata.i_gst_business_name);
        fdata.append("i_gst_business_address", formdata.i_gst_business_address);
        //0-new member 1-renewal member
        fdata.append("member_type", 0);
        setIsLoading(true);
        resp = await insertmember(fdata);
        setIsLoading(false);
        let notify = notification({
          type: resp.status == 0 ? "error" : "success",
          message: resp.message
        });
        notify();
      } else {
        let notify = notification({
          type: "error",
          message: "Enter All Details And Try Again"
        });
        notify();
      }
    } else {
      if (
        // formdata.gender != 0 &&
        formdata.m_name != "" &&
        formdata.mobile_no != "" &&
        formdata.password != "" &&
        formdata.business_name != "" &&
        formdata.business_category != "" &&
        formdata.joining_date != "" &&
        formdata.due_date != ""
      ) {
        let checkMobile = await checkMemberValidation({
          m_id: data.m_id,
          mobile_no: formdata.mobile_no
        });
        if (checkMobile?.status != 0) {
          let fdata = new FormData();
          fdata.append("m_id", data.m_id);
          fdata.append("chpt_id", formdata.chpt_id);
          fdata.append("gender", formdata.gender);
          fdata.append("m_name", formdata.m_name);
          fdata.append("photo", formdata.photo);
          fdata.append("mobile_no", formdata.mobile_no);
          fdata.append("m_email_id", formdata.m_email_id);
          fdata.append("password", formdata.password);
          fdata.append("type", formdata.type);
          fdata.append("business_name", formdata.business_name);
          fdata.append("business_category", formdata.business_category);
          fdata.append("business_desc", formdata.business_desc);
          fdata.append("joining_date", formdata.joining_date);
          fdata.append("due_date", formdata.due_date);
          fdata.append("state_id", formdata.state_id);
          fdata.append("city_id", formdata.city_id);
          fdata.append("reference_m_id", formdata.reference_m_id);
          fdata.append("i_gstno", formdata.i_gstno);
          fdata.append("i_gst_business_name", formdata.i_gst_business_name);
          fdata.append("i_gst_business_address", formdata.i_gst_business_address);
          setIsLoading(true);
          resp = await UpdateMember(fdata);
          setIsLoading(false);
          let notify = notification({
            type: resp.status == 0 ? "error" : "success",
            message: resp.message
          });
          notify();
          setresponse(response + 1);
        } else {
          let notify = notification({
            type: checkMobile.status == 0 ? "error" : "success",
            message: checkMobile.message
          });
          notify();
        }
      } else {
        let notify = notification({
          type: "error",
          message: "Enter All Details And Try Again"
        });
        notify();
      }
    }
    if (resp?.status == 1) setStep(1);
  };

  return (
    <Container>
      <Stack spacing={10} style={{ marginBottom: "15px" }}>
        <Grid container spacing={2}>
          <Grid item xs={6}>
            <Stack spacing={10} style={{ marginBottom: "15px" }}>
              <ChapterSelectDropDown
                dropDownLabel={"Select Chapter"}
                selectedState={formdata}
                chapterKey="chpt_id"
                handleChange={handleChapterSelect}
              />
            </Stack>
          </Grid>
          <Grid item xs={6}>
            <Stack spacing={3} style={{ marginBottom: "15px" }}>
              <label style={{ marginBottom: "10px" }}>Select Member Type</label>
              <Select
                styles={{ marginTop: "0" }}
                isDisabled
                selectedValue
                value={
                  memberTypeOption == null
                    ? { value: 0, label: "Select Chapter" }
                    : memberTypeOption
                      .map((mt) => {
                        if (mt.value == formdata.type) {
                          return { value: mt.value, label: mt.label };
                        }
                      })
                      .filter((n) => n)[0]
                }
                style={{ marginTop: "0px" }}
                name="memberType"
                onChange={handleChaptermemberType}
                options={
                  memberTypeOption != null &&
                  memberTypeOption.map((mt) => {
                    return { value: mt.value, label: mt.label };
                  })
                }
              ></Select>
            </Stack>
          </Grid>
          <Grid item xs={6}>
            <Stack spacing={3} style={{ marginBottom: "15px", marginTop: "5px" }}>
              {/* <label style={{ marginBottom: '10px' }}>Join Date</label> */}
              <LocalizationProvider
                dateAdapter={AdapterDateFns}
                isDisabled
                style={{ marginTop: "15px" }}
              >
                <DatePicker
                  disabled={
                    loginUser?.u_type == 0 ||
                      (loginUser?.u_type == 2 &&
                        loginUser?.p_user_id == 1 &&
                        loginUser?.management_p != 0)
                      ? false
                      : true
                  }
                  type="date"
                  name="joindate"
                  label="Joining Date "
                  value={
                    formdata.joining_date != "" ? moment(formdata.joining_date, "DD-MM-YYYY") : null
                  }
                  inputFormat="dd/MM/yyyy"
                  onChange={(newDate) => {
                    setformdata({
                      ...formdata,
                      joining_date: moment(newDate, "DD-MM-YYYY").format("DD-MM-YYYY"),
                      due_date: moment(newDate, "DD-MM-YYYY").add(1, "years").format("DD-MM-YYYY")
                    });
                  }}
                  renderInput={(params) => <TextField {...params} />}
                />
              </LocalizationProvider>
            </Stack>
          </Grid>
          <Grid item xs={6}>
            <Stack spacing={3} style={{ marginBottom: "15px", marginTop: "5px" }}>
              <LocalizationProvider dateAdapter={AdapterDateFns} style={{ marginTop: "15px" }}>
                <DatePicker
                  disabled={
                    loginUser?.u_type == 0 ||
                      (loginUser?.u_type == 2 &&
                        loginUser?.p_user_id == 1 &&
                        loginUser?.management_p != 0)
                      ? false
                      : true
                  }
                  label="Expire Date "
                  name="expiredate"
                  value={formdata.due_date != "" ? moment(formdata.due_date, "DD-MM-YYYY") : null}
                  inputFormat="dd/MM/yyyy"
                  onChange={(newDate) => {
                    setformdata({
                      ...formdata,
                      due_date: moment(newDate, "DD-MM-YYYY").format("DD-MM-YYYY")
                    });
                  }}
                  renderInput={(params) => <TextField {...params} />}
                />
              </LocalizationProvider>
            </Stack>
          </Grid>
          <Grid item xs={6}>
            <Stack spacing={1.5}>
              <FormControl component="fieldset">
                <FormLabel component="legend">Gender</FormLabel>

                <RadioGroup
                  row // remove this if you want vertical
                  value={formdata.gender || 0}
                  onChange={(e) => {
                    setformdata({
                      ...formdata,
                      gender: e.target.value
                    });
                  }}
                >
                  {gender
                    .filter((g) => g.value !== 0) // remove "Select Gender"
                    .map((g) => (
                      <FormControlLabel
                        key={g.value}
                        value={g.value}
                        control={<Radio />}
                        label={g.label}
                      />
                    ))}
                </RadioGroup>
              </FormControl>
            </Stack>
          </Grid>
          <Grid item xs={6}>
            <Stack spacing={3} style={{ marginBottom: "15px" }}>
              <TextField
                style={{ marginTop: "0px" }}
                fullWidth
                autoComplete="off"
                type="text"
                label="Member Name"
                name="m_name"
                value={formdata?.m_name}
                onChange={setnewformdata}
              />
            </Stack>
          </Grid>
          <Grid item xs={6}>
            <Stack spacing={3} style={{ marginBottom: "15px" }}>
              <TextField
                style={{ marginTop: "0px" }}
                fullWidth
                autoComplete="off"
                type="email"
                label="Member Email Id"
                name="m_email_id"
                value={formdata?.m_email_id}
                onChange={setnewformdata}
              />
            </Stack>
          </Grid>
          <Grid item xs={6}>
            <Stack spacing={3} style={{ marginBottom: "15px" }}>
              <TextField
                inputProps={{ inputMode: "numeric", pattern: "[0-9]*" }}
                style={{ marginTop: "0px" }}
                fullWidth
                autoComplete="off"
                type="number"
                label="Member Contact No"
                onWheel={(e) => e.target.blur()}
                name="mobile_no"
                value={formdata?.mobile_no}
                onChange={setnewformdata}
              />
            </Stack>
          </Grid>
          <Grid item xs={6}>
            <Stack spacing={3} style={{ marginBottom: "15px" }}>
              <TextField
                style={{ marginTop: "0px" }}
                fullWidth
                autoComplete="off"
                type="text"
                label="Member Password"
                name="password"
                value={formdata?.password}
                onChange={setnewformdata}
              />
            </Stack>
          </Grid>
          <Grid item xs={6}>
            <Stack spacing={3} style={{ marginBottom: "15px" }}>
              <TextField
                style={{ marginTop: "0px" }}
                fullWidth
                autoComplete="off"
                type="text"
                label="Business Name"
                name="business_name"
                value={formdata?.business_name}
                onChange={setnewformdata}
              />
            </Stack>
          </Grid>
          <Grid item xs={6}>
            <Stack spacing={3} style={{ marginBottom: "15px" }}>
              <TextField
                style={{ marginTop: "0px" }}
                fullWidth
                autoComplete="off"
                type="text"
                label="Business Category"
                name="business_category"
                value={formdata?.business_category}
                onChange={setnewformdata}
              />
            </Stack>
          </Grid>
          <Grid item xs={6}>
            <Stack spacing={3} style={{ marginBottom: "15px" }}>
              <TextField
                style={{ marginTop: "0px" }}
                fullWidth
                autoComplete="off"
                type="text"
                label="Business Description"
                name="business_desc"
                value={formdata?.business_desc}
                onChange={setnewformdata}
              />
            </Stack>
          </Grid>
          <Grid item xs={6}>
            <Stack spacing={10} style={{ marginBottom: "15px" }}>
              <label style={{ marginBottom: "10px" }}>Select State</label>
              <Select
                value={
                  statelist == null
                    ? { value: 0, label: "Select State" }
                    : statelist
                      .map((c) => {
                        if (c.state_id == formdata.state_id) {
                          return { value: c.state_id, label: c.state_name };
                        }
                      })
                      .filter((n) => n)[0]
                }
                style={{ marginTop: "0px" }}
                name="state_id"
                onChange={handleStateSelect}
                options={
                  statelist != null &&
                  statelist.map((sta) => {
                    return { value: sta.state_id, label: sta.state_name };
                  })
                }
                isDisabled={true}
              ></Select>
            </Stack>
          </Grid>
          <Grid item xs={6}>
            <Stack spacing={10} style={{ marginBottom: "15px" }}>
              <label style={{ marginBottom: "10px" }}>Select City</label>
              <Select
                value={
                  citylist == null
                    ? { value: 0, label: "Select State" }
                    : citylist
                      .map((c) => {
                        if (c.city_id == formdata.city_id) {
                          return { value: c.city_id, label: c.city_name };
                        }
                      })
                      .filter((n) => n)[0]
                }
                style={{ marginTop: "0px" }}
                name="city_id"
                onChange={handleCitySelect}
                options={
                  citylist != null &&
                  citylist.map((c) => {
                    return { value: c.city_id, label: c.city_name };
                  })
                }
                isDisabled={true}
              ></Select>
            </Stack>
          </Grid>
          <Grid item xs={6}>
            <Stack spacing={10} style={{ marginBottom: "15px" }}>
              <label style={{ marginBottom: "10px" }}>Reference By</label>
              <Select
                value={
                  memberlist == null
                    ? { value: 0, label: "Select Chapter" }
                    : memberlist
                      .map((c) => {
                        if (c.m_id == formdata.reference_m_id) {
                          return {
                            value: c.m_id,
                            label: c.m_name + " (" + c.business_name + ") [" + c.chpt_name + "] "
                          };
                        }
                      })
                      .filter((n) => n)[0]
                }
                style={{ marginTop: "0px" }}
                name="reference_m_id"
                onChange={(e) => {
                  setformdata({ ...formdata, reference_m_id: e.value });
                }}
                options={
                  memberlist != null &&
                  memberlist.map((chpt) => {
                    return {
                      value: chpt.m_id,
                      label: chpt.m_name + " (" + chpt.business_name + ") [" + chpt.chpt_name + "] "
                    };
                  })
                }
              ></Select>
            </Stack>
          </Grid>
          <Grid item xs={6}>
            <Stack spacing={3} style={{ marginBottom: "15px" }}>
              <TextField
                style={{ marginTop: "0px" }}
                fullWidth
                autoComplete="off"
                type="text"
                label="GST No"
                name="i_gstno"
                value={formdata?.i_gstno}
                onChange={(e) => {
                  e.target.value = e.target.value.toUpperCase();
                  setnewformdata(e);
                }}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <Button
                        variant="contained"
                        size="small"
                        onClick={() => fetchGstDetailsbynumber(formdata.i_gstno)}
                        disabled={!formdata.i_gstno || formdata.i_gstno.length !== 15 || isLoading}
                      >
                        Verify
                      </Button>
                    </InputAdornment>
                  )
                }}
              />
            </Stack>
          </Grid>
          {isGstVerified && (
            <>
              <Grid item xs={6}>
                <Stack spacing={3} style={{ marginBottom: "15px" }}>
                  <TextField
                    style={{ marginTop: "0px" }}
                    fullWidth
                    autoComplete="off"
                    type="text"
                    label="Business Name (As Per GST)"
                    name="i_gst_business_name"
                    value={formdata?.i_gst_business_name}
                    onChange={setnewformdata}
                    helperText={
                      formdata.i_gstno &&
                      formdata.i_gst_business_name &&
                      originalGstBusinessName &&
                      formdata.i_gst_business_name.trim() !== originalGstBusinessName.trim()
                        ? "business name not matched with GST details"
                        : ""
                    }
                    error={
                      formdata.i_gstno &&
                      formdata.i_gst_business_name &&
                      originalGstBusinessName &&
                      formdata.i_gst_business_name.trim() !== originalGstBusinessName.trim()
                        ? true
                        : false
                    }
                  />
                </Stack>
              </Grid>
              <Grid item xs={12}>
                <Stack spacing={3} style={{ marginBottom: "15px" }}>
                  <TextField
                    style={{ marginTop: "0px" }}
                    fullWidth
                    autoComplete="off"
                    type="text"
                    label="Business Address (As Per GST)"
                    name="i_gst_business_address"
                    value={formdata?.i_gst_business_address}
                    onChange={setnewformdata}
                    multiline
                    rows={2}
                  />
                </Stack>
              </Grid>
            </>
          )}
          <Grid item xs={4}>
            <label style={{ marginBottom: "10px" }}>
              {step == 3 ? "Upload New Image If You Want " : "Upload User Profile Image"}
            </label>
            <br />
            <Stack direction="row" alignItems={"center"} spacing={2}>
              <Button
                variant="contained"
                component="label"
                sx={{ height: 40 }}
                style={{ marginTop: "10px" }}
              >
                Click To Upload File
                <input
                  id="file"
                  name="file"
                  type="file"
                  hidden
                  onChange={(event) => {
                    setformdata({
                      ...formdata,
                      photo: event.currentTarget.files[0]
                    });
                  }}
                  className="form-control"
                />
              </Button>
            </Stack>
          </Grid>
          <Grid item xs={4}>
            <Stack spacing={1} style={{ marginBottom: "15px" }}>
              <strong>Privacy Policy Accept:</strong>
              {data?.m_privacy_policy_status === 1 ? (
                <span>
                  Yes {data?.m_privacy_policy_date && <em>({data.m_privacy_policy_date})</em>}
                </span>
              ) : (
                "No"
              )}
            </Stack>
          </Grid>
          <Grid item xs={4}>
            <Stack spacing={1} style={{ marginBottom: "15px" }}>
              <strong>Terms & Conditions Accept:</strong>
              {data?.m_term_condition_status === 1 ? (
                <span>
                  Yes {data?.m_term_condition_date && <em>({data.m_term_condition_date})</em>}
                </span>
              ) : (
                "No"
              )}
            </Stack>
          </Grid>
        </Grid>
      </Stack>
      {/* <Button
        style={{ marginTop: "15px" }}
        onClick={handleSubmit}
        variant="contained"
        disabled={data?.member_deleted === 1 && step === 3}
      >
        Save
      </Button> */}
      <Button
        variant="contained"
        color="primary"
        style={{ marginTop: "15px" }}
        onClick={handleSubmit}
        disabled={isLoading}
        startIcon={isLoading && <CircularProgress size={20} color="inherit" />}
      >
        Save
      </Button>
    </Container>
  );
}
